<div class="searchBoxFixed">
    <form #f="ngForm" (ngSubmit)="onSubmitSuche(f.suche)" (ngSubmit)="this.value=''" >
        <div id="searchBOX">
            <mat-form-field class="example-form-field-search" tourAnchor="searchTour" tourAnchor="kollektionTour"  id="header"
                [hideRequiredMarker]="hideRequiredControl.value" >
                <div matPrefix>
                    <img src="assets/images/lupe.svg" class="prefixIcon"  alt="">
                </div>
                <input matInput
                tourAnchor="searchTour"
                [(ngModel)]="value"
                #searchbox
                (focus)="this.value=''"
                [matAutocomplete]="auto"
                (onchange)="_filterLen(value)"
                (ngModelChange)="searchbyBoardname(value)"
                [formControl]="searchValue">
                <mat-autocomplete #auto="matAutocomplete" >
                    <span *ngIf="!closeAutoComplete">
                        <span *ngIf="value !== '' && noBoardFound == false" >
                            <mat-option *ngFor="let board of boardsResults"  [value]="board.board_name" (click)="check(board.board_name)" align="center">
                                <img class="example-option-img" aria-hidden [src]="board.board_avatar" >
                                &nbsp;
                                <span class="mat-caption">{{board.board_screenname}}</span>&nbsp;
                                <!-- <span class="mat-caption"><span class="mdi mdi-star"></span>{{board.board_follower_count}}</span>&nbsp; -->
                                <span class="mat-caption"><span class="mdi mdi-eye"></span>{{board.board_hits_count}}</span>&nbsp;
                            </mat-option>
                        </span>
                        <span *ngIf="value !== '' && noBoardFound == true" >
                            <mat-option  align="center">
                                {{'keyword_$383' | translate}}
                            </mat-option>
                            <!-- <button mat-raised-button color="primary" routerLink="/create">create</button> -->
                        </span>
                    </span>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </form>
</div>
